import React from 'react'

const Certificados = () => {
    return (
        <div className='text-left text-justify container fondotransparente p-5' >
<center ><h1 className='p-5 botonbordeazul text-white px-5 mx-5 py-3'>Entrega de certificados a personal de INPROJUY</h1></center>

<center><h3 className='p-3'>Los empleados de la mencionada entidad ampliaron sus conocimientos, habilidades y aptitudes para poder actuar en situaciones de inminente urgencia y/o emergencia. La capacitación estuvo a cargo de personal de docencia y capacitación de la Dirección Provincial del SAME 107 Jujuy.</h3></center>
          

            <img src="./noticias/img/certificados.jpg" className="centrar img-fluid my-3"/>

            <p>En este sentido, el vicepresidente de Inprojuy felicitó a los empleados "por la buena voluntad con la que se sumaron a esta instancia formativa tan importante, ya que nuestra gestión se caracteriza por estar permanente capacitada y es totalmente necesario que estemos preparados para asistir a las personas que necesiten de estas técnicas para sobrevivir”.</p>


            <p>La iniciativa nació por la preocupación de proteger y preservar la integridad de los trabajadores y de la comunidad, procurando crear conciencia sobre la prevención y disminución de riesgos en el ámbito laboral, domiciliario y también en la vía pública.</p>


            <p>En el mismo acto se realizó la entrega de certificados al personal que realizo el curso de Exel para la Administración Publica, en este caso la capacitación estuvo a cargo de IPAP Jujuy. Estuvieron presentes el vicepresidente José Naser; la gerente general Gabriela Lamas y personal capacitado.</p>

        </div>
    )
}

export default Certificados